import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

declare const __BUILD_TIME__: string;
declare const __BUILD_VERSION__: string;

console.log(`[AOS] Version ${__BUILD_VERSION__} built at ${__BUILD_TIME__}`);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
